module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mVjyLl/tc-custom/9780830872855.jpg?1696873918229",
      "alt": "This image is the cover for the book Reformation and the Irrepressible Word of God"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Reformation and the Irrepressible Word of God\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("According to Scripture, the Word of God is \"living and active\" (Heb 4:12). That affirmation was embraced by the Protestant Reformers, whose understanding of the Christian faith and the church was transformed by their encounter with Scripture. It is also true of the essays found in this volume, which brings together the reflections of church historians and theologians originally delivered at Trinity Evangelical Divinity School on the occasion of the 500th anniversary of the Reformation. As they consider historical, hermeneutical, theological, and practical issues regarding the Bible, these essays reveal that the irrepressible Word of God continues to transform hearts and minds.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Scott M. Manetsch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Scott M. Manetsch (PhD, University of Arizona) is professor of church history at Trinity Evangelical Divinity School. He is the associate general editor of the Reformation Commentary on Scripture and the author of "), _c('em', [_vm._v("Calvin's Company of Pastors: Pastoral Care and the Emerging Reformed Church, 1536-1609")]), _vm._v(".")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0